import './index.css';
const getContainerStyles = ({ paddingTop, paddingBottom, maxWidth, minHeight, }) => {
    const containerStyles = {};
    if (paddingTop !== undefined) {
        containerStyles.paddingTop = `${paddingTop}px`;
    }
    if (paddingBottom !== undefined) {
        containerStyles.paddingBottom = `${paddingBottom}px`;
    }
    if (maxWidth !== undefined) {
        containerStyles.maxWidth = `${maxWidth}${isNaN(+maxWidth) ? '' : 'px'}`;
    }
    if (minHeight !== undefined) {
        containerStyles.minHeight = `${minHeight}px`;
    }
    return containerStyles;
};

export { getContainerStyles };
//# sourceMappingURL=utils.js.map
